// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"c0379f9f","633":"d426292f"}[chunkId] + ".chunk.js";
};